import React, { useState, useEffect } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";
import "../assets/styles/local/header.css";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "react-bootstrap";
import { user_logout } from "../redux/actions/action";
import { getChatRooms } from "../redux/actions/chatActions";
import messageImage from "../assets/images/messageImage.svg";
import editIcon from "../assets/icons/editIcon.svg";
import logOut from "../assets/icons/logOut.svg";
import search from "../assets/images/search.svg";
import UserNotificationMenu from "../components/Notifications/UserNotificationMenu";
import { fetchScreenTranslations } from "../utils/helpers/translations";
import NotificationBell from "../components/Notifications/Notification";

const SupplierHeader = (props) => {
  const [totalMessages, setTotalMessages] = useState(0);
  const [active, setActive] = useState(false);
  const [showpopup, setShowpopup] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const userID = window.localStorage.getItem("userid");
  const userjobpost = window.localStorage.getItem("jobpost");
  const userimag = window.localStorage.getItem("userimageurl");
  const userlastname = window.localStorage.getItem("lastname");
  const userfirstname = window.localStorage.getItem("firstname");
  const initials = window.localStorage.getItem("initials");
  const logoutData = useSelector((state) => state.user.userlogout);
  const chatRoomsResponse = useSelector((state) => state?.chat?.chatRooms);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Suppliers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const initialRender = React.useRef(true);

  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );

  const [textcolor, setTextcolor] = useState("#333333");

  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const finDate = new Date(date);
  var date = finDate.toString().split(" ");

  React.useEffect(() => {
    if (!initialRender.current) {
      if (logoutData != null) {
        if (logoutData?.status == true) {
          window.localStorage.clear();
          window.location.reload();
          window.localStorage.clear();
          window.localStorage.clear();
          history.push("/");
        }
      }
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1.status == true) {
          setTextcolor(FetchCompanyDetails1.data[0]?.textcolor);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [logoutData, history]);

  React.useEffect(() => {
    dispatch(getChatRooms(userID));
  }, []);

  React.useEffect(() => {
    let unreadMessages = 0;
    if (chatRoomsResponse.status == true) {
      chatRoomsResponse?.map((room) => {
        if (room.unreadreceivermessagecount > 0) {
          unreadMessages++;
        }
      });
    }
    setTotalMessages(unreadMessages);
  }, [chatRoomsResponse]);

  const isWebView = () => {
    return (
      typeof window.ReactNativeWebView !== "undefined" ||
      navigator.userAgent.includes("wv")
    );
  };

  return (
    <>
      <div
        className="container-fluid"
        style={{ width: "95%", marginTop: "25px", marginBottom: "25px" }}
      >
        <div className="containerBox">
          <div className="stockHeadingbox">
            <div
              className="stockheading"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div className="supplierBoxHeading">
              {props.suppliername ? (
                <div className="HeadingSupplier">
                  {/* Supplier */}
                  {t(" Supplier")}
                </div>
              ) : (
                <div className="HeadingSupplier">
                  {/* Supplier-List */}
                  {t("Supplier-List")}
                </div>
              )}
            </div>
          </div>

          <div className="d-flex flex-wrap respHeader">
            <div onClick={() => history.push("/home")}></div>
            <div
              className="col-12 col-xl-3 col-md-5 col-lg-4 col-sm-8 text-center searchBar"
              style={{
                paddingRight: "10px",
                paddingLeft: "0px",
                backgroundColor: "transparent",
                width: "300px",
              }}
            >
              {path.includes("/chat") ? (
                ""
              ) : (
                <div
                  className={
                    active
                      ? "input-group search_bar_input search_bar_div bg-white"
                      : "input-group search_bar_input search_bar_div-activ"
                  }
                >
                  <div className="search-div1 search-member-input responsive-search-div-member">
                    {" "}
                    {active && (
                      <input
                        autoFocus
                        type="text"
                        onChange={(e) => props.setQuery(e.target.value)}
                        placeholder="Search..."
                        className="noborder search-member-input ps-0"
                        style={{ fontSize: "16px" }}
                      />
                    )}
                  </div>
                  <Image
                    width={22}
                    height={22}
                    src={search}
                    style={{
                      backgroundColor: "transparent",
                      opacity: active ? "40%" : "",
                    }}
                    onClick={() => {
                      setActive(!active);
                    }}
                    className="me-2"
                  />
                </div>
              )}
            </div>
            <div
              className="col-12 pt-5 mt-sm-0 mt-md-2 mt-lg-2 mt-xl-2  col-xl-1 col-md-1 col-lg-1 col-sm-1  align-self-start pt-2 pt-sm-2 pt-xl-0 pt-lg-0 pt-md-0 d-flex"
              style={{ paddingLeft: "0px" }}
            >
              <div className="d-flex searchBarIcon">
                <div className="col-1 col-sm-0 ps-0">
                  <div className="pt-1 headerText pe-0 pe-md-0 pe-xl- pe-sm-0 pe-lg- text-center fw-bold">
                    <NotificationBell />
                  </div>
                </div>
                <div className="col-1 col-sm-0 ps-0 mx-4 ps-1">
                  <div className="pt-1 headerText pe-0 pe-md-0 pe-xl- pe-sm-0 pe-lg-  text-center fw-bold">
                    <Link to="/chat" style={{ position: "relative" }}>
                      {totalMessages > 0 && (
                        <div
                          className="message-icon-main noty-iconspoint"
                          style={{
                            backgroundColor: "#95A7C6",
                          }}
                        >
                          <span
                            style={{
                              color: "white",
                              fontSize: "8px",
                              fontWeight: "500",
                            }}
                          >
                            {totalMessages}
                          </span>
                        </div>
                      )}
                      <Image width={22} height={24} src={messageImage} />
                    </Link>
                  </div>
                </div>

                <div className="col-1 col-sm-0 mt-0 mt-sm-0 px-0 text-center">
                  <div className="ps-xl-4 ps-4 ps-lg-2 ps-md-2 ps-sm-2 ps-xxl-2">
                    <div className="avatar my-1">
                      {userimag ? (
                        <img
                          alt=""
                          src={userimag}
                          height="32px"
                          width="32px"
                          className="profileButton"
                          onClick={() => {
                            setShowpopup(!showpopup);
                          }}
                        />
                      ) : (
                        <div className="">
                          <div
                            className="profileButton"
                            onClick={() => {
                              setShowpopup(!showpopup);
                            }}
                          >
                            {/* below is for abbr using names */}
                            {/* {userlastname
                              ? userfirstname[0]?.toUpperCase() +
                                "" +
                                userlastname[0]?.toUpperCase()
                              : userfirstname?.slice(0, 2).toUpperCase()} */}
                            {/* below is for using initials from login API */}
                            {initials ?? ""}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showpopup && (
        <div className="d-flex justify-content-end me-5 pe-5 cardOuter">
          <div className="popupcard rounded">
            <div
              className="popupfirst"
              onClick={() => {
                setShowpopup(false);
              }}
            >
              <div
                className="mt-4 mb-3"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {userimag ? (
                  <img className="imgpopup" src={userimag} alt="" />
                ) : (
                  <p className="profilebtn">
                    {/* below is for abbr using names */}
                    {/* {userlastname
                      ? userfirstname[0]?.toUpperCase() +
                        "" +
                        userlastname[0]?.toUpperCase()
                      : userfirstname.slice(0, 2).toUpperCase()} */}
                    {/* below is for using initials from login API */}
                    {initials ?? ""}
                  </p>
                )}
              </div>
              <h6 className="fw-bold luna" style={{ color: `${textcolor}` }}>
                {" "}
                {userfirstname + " " + userlastname}
              </h6>
              <h6 className="managerrole" style={{ color: `${textcolor}` }}>
                {" "}
                {userjobpost === "null" ? "" : userjobpost}
              </h6>
            </div>
            <div className="popupsecond">
              <div className="py-4 ">
                <div
                  className={
                    isWebView() === true
                      ? "d-none editpro1 d-flex gap-3 ps-4"
                      : "editpro1 d-flex gap-3 ps-4"
                  }
                >
                  <img src={editIcon} alt="" width={15} />
                  <p
                    className="py-2 mb-0 pointer"
                    onClick={() => {
                      history.push("/profile");
                    }}
                  >
                    {/* Edit profile */}
                    {t("Edit profile")}
                  </p>
                </div>

                <div className="d-flex gap-3 dropdown-item logoutpop ps-4 py-2">
                  <img src={logOut} alt="" width={15} />
                  <p
                    className="mb-0"
                    onClick={() => {
                      dispatch(user_logout(userID));
                      localStorage.removeItem("myAppName");
                      localStorage.setItem("logoutUrl", "/");
                    }}
                    style={{ color: `${textcolor}`, cursor: "pointer" }}
                  >
                    {/* Logout */}
                    {t("Log out")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SupplierHeader;
